module.exports = __webpack_public_path__ + "media/images/favicon/favicon-3b14b2d81151e8570e9198ceb8619475.ico";